module.exports = __webpack_public_path__ + "img/ornament-right.a16c19ca.png";